module.exports = __webpack_public_path__ + "static/media/learning-center.e22103ee.svg";